'use strict';

var parseSetMethodArgs = require('../utils/model.utils').parseSetMethodArgs;
var BBModel = Backbone.Model;
var BBModelSet = BBModel.prototype.set;

var setNestedValue = function(nestedProp, value, options) {
    var attrs = Odigeo._.isFunction(Odigeo._.get(value, 'toJSON')) ? value.toJSON() : value;
    var collectedEvents;
    nestedProp.__collectedEvents = {};
    nestedProp.set(attrs, options);
    collectedEvents = Odigeo._.clone(nestedProp.__collectedEvents);
    delete nestedProp.__collectedEvents;
    return collectedEvents;
};

var triggerEventsPerProp = function(collectedEvents, options) {
    Odigeo._.each(collectedEvents, Odigeo._.bind(function(events, prop) {
        events.change = true;
        Odigeo._.each(events, Odigeo._.bind(function(exists, event) {
            this.trigger(event + ':' + prop, this, this.get(prop), options);
        }, this));
    }, this));
};

var triggerModelEvents = function(collectedEvents, options) {
    var events = Odigeo._.merge.apply(null, Odigeo._.toArray(collectedEvents));
    events.change = true;
    Odigeo._.each(events, Odigeo._.bind(function(exists, event) {
        this.trigger(event, this, options);
    }, this));
};

var NestedModel = BBModel.extend({
    toJSON: function() {
        var json = BBModel.prototype.toJSON.call(this);
        Odigeo._.each(this.nestedProps, function(Class, prop) {
            json[prop] = json[prop].toJSON();
        });
        return json;
    },
    set: function() {
        var args = parseSetMethodArgs(arguments);
        var nestedProps = Odigeo._.keys(this.nestedProps);
        var simpleAttrs = Odigeo._.omit(args[0], nestedProps);
        var nestedAttrs = Odigeo._.pick(args[0], nestedProps);
        var options = args[1];
        var nestedPropsEvents = {};
        var silentOptions = Odigeo._.extend({}, options, {silent: true});
        if (Odigeo._.isEmpty(this.attributes)) {
            initNestedProps.call(this, silentOptions);
        }
        BBModelSet.call(this, simpleAttrs, silentOptions);
        var simplePropsEvents = Odigeo._.reduce(this.changedAttributes(), function(events, value, prop) {
            events[prop] = {
                change: true,
            };
            return events;
        }, {});
        Odigeo._.each(nestedAttrs, Odigeo._.bind(function(value, prop) {
            var nestedProp = this.get(prop);
            var events;
            if (Odigeo._.has(nestedProp, 'models') || Odigeo._.has(nestedProp, 'attributes')) {
                events = setNestedValue(nestedProp, value, options);
            }
            if (!Odigeo._.isEmpty(events)) {
                nestedPropsEvents[prop] = events;
            }
        }, this));
        var collectedEvents = Odigeo._.extend(nestedPropsEvents, simplePropsEvents);
        if (!Odigeo._.isEmpty(collectedEvents)) {
            triggerEventsPerProp.call(this, collectedEvents, options);
            triggerModelEvents.call(this, collectedEvents, options);
        }
    },
});

var toRawObject = function(obj) {
    return Odigeo._.isFunction(Odigeo._.get(obj, 'toJSON')) ? obj.toJSON() : obj;
};

var initNestedProps = function(options) {
    var defaults = Odigeo._.result(this, 'defaults', {});
    Odigeo._.each(this.nestedProps, Odigeo._.bind(function(Class, prop) {
        BBModelSet.call(this, prop, new Class(toRawObject(defaults[prop]), options), options);
    }, this));
};

var collectEvent = function(eventName) {
    Odigeo._.defaults(this, {__collectedEvents: {}});
    if (!Odigeo._.includes(eventName, ':')) {
        this.__collectedEvents[eventName] = true;
    }
};

NestedModel.extend = function(properties, classProperties) {
    return BBModel.extend.call(NestedModel, Odigeo._.extend({}, properties, {
        initialize: function(attrs, options) {
            var initialize = properties.initialize || properties.constructor || Odigeo._.noop;
            this.nestedProps = properties.nestedProps || {};
            Odigeo._.each(this.nestedProps, Odigeo._.bind(function(Class, prop) {
                var nestedProp = this.get(prop);
                nestedProp.on('all', collectEvent);
            }, this));
            initialize.call(this, attrs, options);
        },
    }), classProperties);
};

module.exports = NestedModel;
